import { RuleVariant } from '@procureai/rule-builder';
import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

export const ruleDetailDialogFormSchema = z.object({
  name: z.string().min(3),
  responsibleUsers: z.array(z.string()),
  variant: z.enum(RuleVariant),
});

export type RuleDetailDialogFormData = z.infer<typeof ruleDetailDialogFormSchema>;

export const ruleDetailDialogDefaultValues: DefaultValues<RuleDetailDialogFormData> = {
  variant: RuleVariant.SOURCING,
};
